import { wa, pageEventTypes } from 'apps/analytics';

export function reportRecommendationsPopupShown(numberOfSubs) {
  wa.triggerPageEvent(pageEventTypes.RECOMMENDATIONS_POPUP_SHOWN, {
    NUMBER_OF_SUBS: numberOfSubs,
  });
}

export function reportRecommendationsSubscribe(frequency, sku, collectionFopIdx) {
  wa.triggerPageEvent(pageEventTypes.RECOMMENDATIONS_ADD_PRODUCT, {
    FREQUENCY: frequency,
    SKU: sku,
    POSITION: collectionFopIdx,
  });
}

export function reportRecommendationsFrequencyChange(frequency, sku) {
  wa.triggerPageEvent(pageEventTypes.RECOMMENDATIONS_FREQUENCY, {
    FREQUENCY: frequency,
    SKU: sku,
  });
}

export function reportRecommendationsQuantityChange(quantity, sku) {
  wa.triggerPageEvent(pageEventTypes.RECOMMENDATIONS_QUANTITY, {
    QUANTITY_UPDATE: quantity,
    SKU: sku,
  });
}

export function reportRecommendationsDontShowAgainClicked() {
  wa.triggerPageEvent(pageEventTypes.RECOMMENDATIONS_NO_SHOW_AGAIN_CLICKED);
}
